<template>
    <v-dialog v-model="value.status" persistent max-width="280">
      <v-card>
        <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
           <v-flex xs12 class="title">{{value.message}}</v-flex>
           <v-flex xs12 class="text-xs-right">
           <v-btn
              @click="close"
              color="success"
              small
              class="white--text">
              ok
            </v-btn>
           </v-flex>
          </v-flex>
        </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    close () {
      this.$setApprovalNotification({vueinstance: this, status: false, message: ''})
      this.$store.dispatch('setTitle', {title: 'Business Trip'})
      this.$store.dispatch('Action/reset')
      this.$router.push({name: 'Worklist'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/ApprovalNotification.vue